import * as ActionTypes from '../../actions/allActions'

const accountSecurity = (state = { canSubmit: false, form_errors: {}, showModal: false, result: false }, action) => {
	switch (action.type) {
		case ActionTypes.ACCOUNT_SECURITY_METACHANGE:
			return { ...state, ...action.changes }
		case ActionTypes.UPDATE_PASSWORD_REQUEST:
			return { ...state, form_errors : {} }
		case ActionTypes.UPDATE_PASSWORD_SUCCESS:
			return { ...state, showModal: true, result: true}
		case ActionTypes.UPDATE_PASSWORD_FAILURE:
			return { ...state, showModal: true, result: false}
		case ActionTypes.BACKEND_FORM_ERROR:
			return { ...state, form_errors: action.form_errors }
		case ActionTypes.TOGGLE_ACCOUNT_SECURITY_MODAL:
			return { ...state, showModal: !state.showModal }
		default:
			return state
	}
}

export default accountSecurity


// WEBPACK FOOTER //
// ./src/reducers/metadata/accountSecurity.js